import { Component, OnInit } from '@angular/core';
import { PosFloatingActionButtonService } from 'src/app/@core/services/pos-floating-action-button.service';

@Component({
  selector: 'app-pos-customer',
  templateUrl: './pos-customer.component.html',
  styleUrls: ['./pos-customer.component.sass']
})
export class PosCustomerComponent implements OnInit {

  constructor(private floatingService: PosFloatingActionButtonService) {
    floatingService.removeItems();
  }

  ngOnInit(): void {
  }

}
